export enum StatiEvento {
  IN_BOZZA = 'BOZ',
  RACCOLTA_DATI = 'RAC',
  ATTESA_EMERGENZA = 'ATT',
  POST_EMERGENZA = 'POS',
  RACCOLTA_DATI_PE = 'RDP',
  EMERGENZA_NON_RICONOSCIUTA = "ENR"
}

